export function getAppCommitSha() {
  return process.env.APP_COMMIT_SHA || 'development'
}

export function getShortAppCommitSha() {
  if (process.env.APP_COMMIT_SHORT_SHA) return process.env.APP_COMMIT_SHORT_SHA
  const sha = getAppCommitSha()
  return sha.slice(0, 7)
}
